// extracted by mini-css-extract-plugin
module.exports = {"animateHorizontalDone":"animation_animateHorizontalDone__1Uv9p","animateVerticalDone":"animation_animateVerticalDone__3k9zE"};